export default "__VITE_ASSET__7d1e3af0__"